//T71 mystery item - parametric version.

// VARIABLES. → from liquid settings.
window.threshold = parseInt($(".shipping-wrapper .fourth-offer").data("value"))*100; // eg $200 in cents
window.id_freeitem = $(".shipping-wrapper .fourth-offer").data("variant-id");
window.discountedId = window.id_freeitem;

//announce msg.
var announceEl = document.querySelector(".ajax-announcement-wrapper p");
var currentmessage = announceEl.innerHTML;

//safety variable to check if free item added. (ie in cart & threshold met)
window.freeitem_added = false;
//general var for adder.
lots_of_freestuff_already_done = false;

//Function logic for progress & mystery display-
$(function () {

  //for any testing
  if (window.mystery_testing === true) return;

  console.log("JQ Doc ready - T71");
  $(document).on('click', '.add-free-item-btn', function (e) {
    // only do the upsell if not done already.
    if (lots_of_freestuff_already_done == false && window.freeitem_added == false) {
      //only interrupt normal ATC if the upsell action is triggered.
      e.preventDefault();
      e.stopPropagation();
      const $button = $(this); // capture reference to button
      let announcementWrapper = $(".ajax-announcement-wrapper");
      let checkoutprice = $('.checkoutprice');

      //button span for loading animation
      const $span = $button.find('span');
      const $bar = $button.closest('.free-item-bar'); // reference to parent
      console.log("checkbox upsell stuff");

      lots_of_freestuff_already_done = true;
      $span.addClass('btn--loading').css('pointer-events', 'none');

      jQuery.ajax({
        url: '/cart/add.js',
        type: 'post',
        dataType: 'json',
        data: {
          id: discountedId,
          quantity: 1,
          properties: {
            "_free_gift": "true"
          }
        }
      })
        .then(function () {
          //cart height? check!
          announcementWrapper.addClass("only-free-bar");
          document.dispatchEvent(new CustomEvent('cart:build')); 
        })
        .then(function () {
          
          setTimeout(function () {
            //new safety line.
              if (typeof nvd_init === "function") {
              nvd_init();
                     let nvd_item = document.querySelector('[href*="/products/navidium-shipping-protection"]');
                      if (nvd_item) nvd_item.parentNode.parentNode.style.display = 'none';
              }
              else {
              checkoutprice.load(location.href + ' .checkoutprice'); 
                   let nvd_item = document.querySelector('[href*="/products/navidium-shipping-protection"]');
                   if (nvd_item) nvd_item.parentNode.parentNode.style.display = 'none';
              }

          }, 125);
         
        })
        .then(function () {
          $span.removeClass('btn--loading').css('pointer-events', '');
          $bar.addClass("no-free-bar");
          announcementWrapper.removeClass("only-free-bar");
          lots_of_freestuff_already_done = false;
   //       checkoutprice.load(location.href + ' .checkoutprice');  
        });
    }
  });

   //Function to get cart & apply updates.
        function applyFreeItemDiscount() {
            //console.log("compare function executing - cart AB test");
            $.getJSON('/cart.js', function (cart) {
            let hasDiscountedItem = false;
            let freeItemCount = 0;
            let freeItemsTotal = 0;
            let freeitembar = $(".free-item-bar");
            let checkoutprice = $('.checkoutprice');
            let announcementWrapper = $(".ajax-announcement-wrapper");

            // Detect free item in cart
            for (const item of cart.items) {
                if (item.key.includes(window.discountedId) &&
                    item.properties &&
                    item.properties._free_gift === "true") {
                hasDiscountedItem = true;
                // if discount way.
                //freeItemsTotal += item.final_line_price;

                //shopify script way:
                    freeItemsTotal += item.original_line_price;

                freeItemCount++;
                break;
                }
            }

            // Calculate subtotal (adjusted if needed)
            const subtotalExcludingFree = cart.original_total_price - freeItemsTotal;

            // Show bar ONLY if threshold met and no free item in cart
            if (subtotalExcludingFree >= window.threshold && freeItemCount === 0) {
              announcementWrapper.addClass("only-free-bar");  
              setTimeout(()=>{
                  
                  freeitembar.removeClass("no-free-bar");
                }, 100);
                
                window.freeitem_added = false;

            } else {
                // Case: threshold not reached, no free item in cart
                freeitembar.addClass("no-free-bar");
                announcementWrapper.removeClass("only-free-bar");

                // Case: free item in cart and threshold met
                if (freeItemCount > 0 && subtotalExcludingFree >= window.threshold) {
                window.freeitem_added = true;

                cart.items.forEach(item => {
                    if (item.key.includes(window.discountedId) &&
                        item.properties &&
                        item.properties._free_gift === "true") {          
                                  // new 16/09: Separated DOM update, to avoid delay conditions.  
                                  waitForElement(`.cart__item[data-key="${item.key}"]`).then(el => {
                                  el.setAttribute('data-free-gift', 'true');
                                  el.classList.add('is-free-gift');

                                  const priceSpan = el.querySelector('.cart__price span[aria-hidden="true"]');
                                  if (priceSpan) {
                                    priceSpan.textContent = 'FREE';
                                    priceSpan.classList.add("new-price");
                                  }
                                }).catch(err => console.warn(err.message));            
                  }
                });

                // Case: free item in cart but threshold not met
                } else if (freeItemCount > 0 && subtotalExcludingFree < window.threshold) {
                window.freeitem_added = false;

                cart.items.forEach(item => {
                    if (item.key.includes(window.discountedId) &&
                        item.properties &&
                        item.properties._free_gift === "true") {

                    $.ajax({
                        url: '/cart/change.js',
                        method: 'POST',
                        dataType: 'json',
                        data: {
                        id: item.key,
                        quantity: 0     
                        }
                    })
                    .then(function () {
                        window.freeitem_added = false;
                        document.dispatchEvent(new CustomEvent('cart:build'));
                    })
                    .then(function () {
                        setTimeout(function () {
                        checkoutprice.load(location.href + ' .checkoutprice');
                        let nvd_item = document.querySelector('[href*="/products/navidium-shipping-protection"]');
                        if (nvd_item) nvd_item.parentNode.parentNode.style.display = 'none';
                        }, 275);
                        //on removal, nvd handles update already.
                    })
                    .fail((err) => {
                        console.error('Failed to remove free gift:', err);
                    });
                    }
                });
                }
            }

            //update success text.
             mystery_successtext();
            });
        }

      // Run at start
      console.log("T71 init.")
      setTimeout(()=>{ applyFreeItemDiscount(); }, 400);

      // Run on cart updates (theme or self-iniated)
      document.addEventListener('cart:updated', () => { 
        console.log("T71 - Cart updated"); 
            setTimeout(()=>{applyFreeItemDiscount(); },375);
      });

      // run on own update
          document.addEventListener('cart:build', () => { 
        console.log("T71 - Cart built (Mystery addition/removal)"); 
            setTimeout(()=>{applyFreeItemDiscount(); },375);
      });

      //run on normal ATC
      document.addEventListener('ajaxProduct:added', function(evt) { 
        console.log("T71 - after item ATC"); 
            setTimeout(()=>{applyFreeItemDiscount(); },375);
      });

      // checker function #6
      function mystery_successtext(){
          if (window.freeitem_added == true) {
            announceEl.innerHTML = 'Free Mystery Item added!';
          } else {
            announceEl.innerHTML = currentmessage;
          }
        }

// Utility: wait until a selector exists in the DOM (free label)
    function waitForElement(selector, timeout = 2000) {
      return new Promise((resolve, reject) => {
        const el = document.querySelector(selector);
        if (el) return resolve(el);

        const observer = new MutationObserver(() => {
          const el = document.querySelector(selector);
          if (el) {
            observer.disconnect();
            resolve(el);
          }
        });

        observer.observe(document.body, { childList: true, subtree: true });

        setTimeout(() => {
          observer.disconnect();
          reject(new Error(`Timeout: ${selector} not found`));
        }, timeout);
      });
    }

//end of document ready.
});

/* old Mutation observer, only kept as backup.
    const debouncedApply = debounce(() => {
      //applyFreeItemDiscount();
      //mystery_successtext();
      console.log("T71 script run!");
    }, 100);

    const observerTarget = document.querySelector(".checkoutprice");
      if (observerTarget) {
    const observer = new MutationObserver(debouncedApply);
    observer.observe(observerTarget, { childList: true, characterData: true, subtree: true });

      }

    function debounce(fn, delay) {
      let timer;
      return function(...args) {
        clearTimeout(timer);
        timer = setTimeout(() => fn.apply(this, args), delay);
      };
    }
*/



